<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>Мониторинг</h2>
    </div>
    <div class="monitoring-sections">
      <EmotionalDynamicsMonitoring
          :has-subscription="hasSubscription"
          @showOrderForm="showOrderForm = true"
      />
      <SoftSkillsDynamics
          :has-subscription="hasSubscription"
          @showOrderForm="showOrderForm = true"
      />
      <EmotionalStability
          :has-subscription="hasSubscription"
          @showOrderForm="showOrderForm = true"
      />
      <ManagementAnalyticsCards
          :has-subscription="hasSubscription"
          @showOrderForm="showOrderForm = true"
      />
    </div>

    <NewOrderForm
        v-if="showOrderForm"
        :open="showOrderForm"
        @close="showOrderForm = false"
    />
  </div>
</template>

<script>
import EmotionalDynamicsMonitoring from "@/components/Analytics/EmotionalDynamicsMonitoring.vue";
import SmallCardWrapper from "@/components/Widgets/WidgetCard.vue";
import TopEmotionsCard from "@/components/Analytics/TopEmotionCards.vue";
import SoftSkillsDynamics from "@/components/Analytics/SoftSkillsDynamics.vue";
import EmotionalStability from "@/components/Analytics/EmotionalStabillity.vue";
import DomainsDonutChart from "@/components/Analytics/DomainsDonutChart.vue";
import ManagementAnalyticsCards from "@/components/Analytics/ManagementAnalyticsCard.vue";
import EiProfileCards from "@/components/Analytics/EiProfilesCards.vue";
import {computed, onBeforeMount, ref, watch} from "@vue/runtime-core";
import {useStore} from "vuex";
import NewOrderForm from "@/views/Orders/OrderForm.vue";
import useCheckRights from "@/mixins/useCheckRights";
import { hasSubscriptionAnalyticsAccess } from "@/utils/subscriptionAnalyticsAccess";

export default {
  components: {
    NewOrderForm,
    EiProfileCards,
    ManagementAnalyticsCards,
    DomainsDonutChart,
    EmotionalStability, SoftSkillsDynamics, TopEmotionsCard, SmallCardWrapper, EmotionalDynamicsMonitoring},
  setup() {
    const store = useStore();
    const {getRight} = useCheckRights();
    const showOrderForm = ref(false);
    const user = computed(() => store.state.profile.profile);
    const permittedSubscriptions = computed(() => store.state.subscription.permittedSubscriptions);

    const hasSubscription = computed(() => {
      return hasSubscriptionAnalyticsAccess(permittedSubscriptions.value, 'monitoring');
    });

    const loadPermittedSubscriptions = () => {
      if (!permittedSubscriptions.value || !permittedSubscriptions.value.length) {
        if (getRight('subscription') && user.value?.id) {
          store.dispatch('subscription/getPermittedSubscriptions', user.value?.company?.id ?? null);
        }
      }
    };

    onBeforeMount(() => {
      store.dispatch("group/getGroups");
      store.dispatch('analytics/getMonitoringData');
    });

    watch(
        () => [user.value?.id, user.value?.company?.id],
        () => {
          loadPermittedSubscriptions();
        },
        {immediate: true}
    );

    return {
      showOrderForm,
      hasSubscription
    }
  }
}
</script>

<style scoped lang="scss">
.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.monitoring-sections {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
